var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#favicon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 4.9a6 6 0 0 0-1.452.065c-.348.06-.681.191-.978.381-.303.206-.992.85-1.385 1.275s-.682.733-1.452 1.7c-.548.69-1.215 1.547-1.986 2.565-.807 1.07-1.237 1.583-1.355 1.583-.2 0-.319-.271-.43-.799-.044-.234-.089-.425-.118-.564-.163-.843-.645-.645-1.052-.476a1.29 1.29 0 0 0-.823 1.34c.015.147 0 .081.082.69.007.05.148 1.084.215 1.37.051.241.126.476.237.703.089.183.222.352.392.469.178.11.386.176.6.198.652.08 1.09-.162 1.778-.946z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.689 19.115c-1.815 0-3.2-.527-4.142-1.568q-1.422-1.58-1.422-4.514c0-2 .496-3.531 1.482-4.601.985-1.07 2.415-1.612 4.282-1.612q1.9.002 3.422.696l-1.281 1.78c-1.104-.359-1.46-.373-2.156-.373-2.074 0-3.12 1.363-3.12 4.088 0 1.334.26 2.33.779 2.998q.776 1.001 2.274 1.003a6.6 6.6 0 0 0 3.223-.835v2.198a5.2 5.2 0 0 1-1.46.572 9.6 9.6 0 0 1-1.881.168"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "favicon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.125 4.834h15.75v14.332H4.125z"
  })))));
};
export default SvgFavicon;